import React from 'react';
import PropTypes from 'prop-types';

const Lock = ({ size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || 25}
    height={size || 25}
    viewBox="0 0 25 25"
  >
    <g fill="none" fillRule="evenodd">
      <g fill="#BFBFBF">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M15 10V8c0-1.598-1.249-2.904-2.824-2.995L12 5c-1.657 0-3 1.343-3 3v2H6V8c0-3.314 2.686-6 6-6s6 2.686 6 6v2c1.105 0 2 .895 2 2v8c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2v-8c0-1.105.895-2 2-2h9zm-3 3c-1.105 0-2 .895-2 2 0 .754.417 1.41 1.031 1.75l-.023.123L11 17v1c0 .552.448 1 1 1 .513 0 .936-.386.993-.883L13 18v-1c0-.086-.01-.17-.032-.25C13.583 16.41 14 15.755 14 15c0-1.105-.895-2-2-2z"
                  transform="translate(-1146 -2919) translate(322.5 724) translate(288 1721) translate(0 450) translate(536 24)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

Lock.propTypes = {
  size: PropTypes.func,
};
export default Lock;
